import Player from '@vimeo/player';

export default {
  mounted() {
    // Function to adjust button position
    const adjustButtonPosition = () => {
      const buttonPos = document.getElementById('vimeo_video--button');
      const items = document.querySelectorAll('div.item.elevation-soft');
      if (items.length > 0) {
        let rightMostEdge = 0;

        items.forEach((item) => {
          const itemRightEdge = item.getBoundingClientRect().right;
          if (itemRightEdge > rightMostEdge) {
            rightMostEdge = itemRightEdge;
          }

          buttonPos.style.left = `${(rightMostEdge - 20)}px`;
        });
      } else {
        buttonPos.style.right = '20px';
      }
    };

    // Run this code after the DOM is ready
    adjustButtonPosition();

    // Add event listener for window resize
    window.addEventListener('resize', adjustButtonPosition);
  },

  methods: {
    toggleVideoAction() {

      // Image paths for play and pause icons
      const pauseImg = '_resources/app/client/dist/images/pause_circle.svg';
      const playImg = '_resources/app/client/dist/images/play_circle.svg';

      // Video and iframe element
      const videoWrapper = document.getElementById('hero-video-wrapper');
      const iframe = videoWrapper?.querySelector('iframe'); // Optional chaining to avoid errors
      const buttonImg = videoWrapper?.querySelector('#vimeo_video--button img');

      if (iframe) {

        // Initialize Vimeo Player
        const player = new Player(iframe);

        // Check the play/pause state
        player.getPaused().then((paused) => {
          if (paused) {
            // Play the video
            player.play().then(() => {
              if (buttonImg) buttonImg.src = pauseImg; // Update button to show pause icon
              console.log(buttonImg, 'pause src')
            }).catch((error) => {
              console.error('Error playing the video:', error);
            });
          } else {
            // Pause the video
            player.pause().then(() => {
              if (buttonImg) buttonImg.src = playImg; // Update button to show play icon
            }).catch((error) => {
              console.error('Error pausing the video:', error);
            });
          }
        }).catch((error) => {
          console.error('Error checking pause state:', error);
        });
      }
    }
  }
};
